const stickyNav = (block, startScrollEl) => {
    const header =  $('.header');
    function resetSticky(block) {
        $(block).removeClass('fixed');
        header.removeClass('sticky-block');
    }

    if ($(block).length && $(startScrollEl).length) {

        let stickySidebar = $(startScrollEl).offset().top + $(block).height(),
            headerHeight;

        function desktopEvent() {
            headerHeight = header.outerHeight();
            if ($(window).scrollTop() + headerHeight > stickySidebar) {
                $(block).addClass('fixed');
                header.addClass('sticky-block');
                $(block).css({'top': headerHeight});
            } else {
                resetSticky(block);
            }
        }

        if ($(window).width() > 768) {
            window.addEventListener('scroll', desktopEvent);
            $(window).trigger('scroll');
        } else {
            $(block).css({'top': 'auto'});
        }

        $(window).on('resize', function () {
            resetSticky(block);
            window.removeEventListener('scroll', desktopEvent);

            if ($(window).width() > 768) {
                stickySidebar =  $(startScrollEl).offset().top + $(block).height();
                window.addEventListener('scroll', desktopEvent);
                $(window).trigger('scroll');
            } else {
                $(block).css({'top': 'auto'});
            }
        });
    }
};
export default stickyNav;